module.exports = __webpack_public_path__ + "img/spr.2b5062e9.png";